import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"

import { Row, Col, Container, Form, Input, FormFeedback, Label, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
// redux
import { useSelector, useDispatch } from "react-redux"

import { Link, useLocation } from "react-router-dom";
import withRouter from "../../components/Common/withRouter"

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin } from "../../store/actions"

// import images
import defaultLogo from "../../assets/images/tahsilat360_logo2.png"
import tahsilat360Logo from "../../assets/images/tahsilat360_logo2_trim.png"

//Import config
import config from "../../config"
import { createSelector } from "reselect";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import {API} from "../../api/urls";
import classnames from "classnames";
import { Modal, ModalHeader, ModalBody } from "reactstrap";




const Login = props => {
  // Tab state
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const initialTab = params.get("type");
  const [activeTab, setActiveTab] = useState(
      initialTab === "company" ? "company" : "account"
  ); // "company" or "account"
  const onlyDigits = v => v.replace(/\D/g, "");

  // Password visibility
  const [passwordShow, setPasswordShow] = useState(false);

  // 2FA states
  const [twoFaRequired, setTwoFaRequired] = useState(false);
  const [frontCode, setFrontCode] = useState(null);
  const [verifyCode, setVerifyCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [contractModal, setContractModal] = useState({
    open  : false,
    title : "",
    html  : "",
    busy  : false
  });

  const CONTRACT_ENDPOINT = {
    CANCELLATION : API.contract_cancel_return_privacy,   //  /api/companies/contract/cancellation-return-privacy
    KVKK         : API.contract_personal_data,          //  /api/companies/contract/personal-data-policy
    SERVICE      : API.contract_service_agreement       //  /api/companies/contract/service-agreement
  };

  // Company logo state
  const [companyLogo, setCompanyLogo] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [companyCode, setCompanyCode] = useState("");

  const [logoLoading, setLogoLoading] = useState(true);
  const sanitizePassword = s => (s ?? '').replace(/\s+/g, '');

  const dispatch = useDispatch();

  // Redux error selector
  const errorData = createSelector(
      state => state.Login,
      state => ({ error: state.error })
  );
  const { error } = useSelector(errorData);

  const openContractModal = async type => {
    setContractModal(prev => ({ ...prev, open:true, busy:true, html:"", title:"" }));
    try {
      const urlFunc = CONTRACT_ENDPOINT[type];   // <-- fonksiyon referansı
      const url     = urlFunc(companyId);        // <-- fonksiyonu çağır
      const res     = await axios.get(url);      // <-- artık doğru URL
      // public → token yok
      if (res.data.statusCode !== 200 || !res.data.data)
        throw new Error(res.data.message || "Sözleşme bulunamadı");

      const titles = {
        CANCELLATION : "İptal / İade Koşulları ve Gizlilik",
        KVKK         : "Kişisel Veriler Politikası",
        SERVICE      : "Hizmet Sözleşmesi"
      };

      setContractModal({
        open  : true,
        busy  : false,
        html  : res.data.data,     // backend “contract” alanı
        title : titles[type]
      });
    } catch (err) {
      setContractModal({
        open  : true,
        busy  : false,
        html  : `<p class="text-danger">Sözleşme bulunamadı.</p>`,
        title : "Uyarı"
      });
      console.error("Contract fetch error:", err);
    }
  };

  const [contactModal, setContactModal] = useState({
    open  : false,
    busy  : false,
    data  : null,   // CompanyPublicInfoDTO
    error : null
  });

  const openContactModal = async () => {
    setContactModal({ open:true, busy:true, data:null, error:null });

    try {
      const res = await axios.get(API.get_company_info_by_domain);   // public ⇒ token yok
      if (res.data.statusCode !== 200 || !res.data.data)
        throw new Error(res.data.message || "Bilgi bulunamadı");

      setContactModal({
        open : true,
        busy : false,
        data : res.data.data,
        error: null
      });
    } catch (err) {
      console.error("Contact fetch error:", err);
      setContactModal({
        open : true,
        busy : false,
        data : null,
        error: "İletişim bilgileri alınamadı"
      });
    }
  };

  const customStyles = `
  /* Font: uygulama genelindeki global font miras alınır (override yok) */
  .login-modern {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    background: linear-gradient(135deg, #f6f8fc 0%, #eef1f8 100%);
    overflow: hidden;
  }
  .login-modern::before,
  .login-modern::after {
    content: "";
    position: absolute;
    border-radius: 50%;
    filter: blur(70px);
    opacity: 0.35;
    z-index: 0;
    pointer-events: none;
  }
  .login-modern::before { width: 440px; height: 440px; top: -130px; right: -90px; background: rgba(229,106,34,0.18); }
  .login-modern::after  { width: 400px; height: 400px; bottom: -140px; left: -110px; background: rgba(34,28,93,0.14); }

  .login-scroll {
    position: relative;
    z-index: 1;
    flex: 1;
    overflow-y: auto;
    display: flex;
    align-items: center;
  }

  .login-card {
    width: 100%;
    max-width: 980px;
    margin: 2rem auto;
    display: grid;
    grid-template-columns: 1.05fr 1fr;
    background: #ffffff;
    border: 1px solid #e9edf5;
    border-radius: 24px;
    box-shadow: 0 24px 60px rgba(34,28,93,0.12);
    overflow: hidden;
  }

  /* Brand panel (açık tema, beyaz ağırlıklı) */
  .login-brand {
    position: relative;
    padding: 2.75rem 2.5rem;
    color: #1f2a44;
    background: linear-gradient(160deg, #fbfcff 0%, #eef1fb 100%);
    border-right: 1px solid #e9edf5;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
  }
  .login-brand::after {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(620px 320px at 115% -15%, rgba(229,106,34,0.12) 0%, transparent 60%);
    pointer-events: none;
  }
  .login-brand > * { position: relative; z-index: 1; }
  .brand-badge {
    display: inline-flex;
    align-items: center;
    gap: .5rem;
    padding: .42rem .85rem;
    background: rgba(34,28,93,0.06);
    border: 1px solid rgba(34,28,93,0.15);
    color: #221c5d;
    border-radius: 999px;
    font-size: .8rem;
    font-weight: 500;
    width: max-content;
  }
  .login-brand h2 {
    font-weight: 700;
    font-size: clamp(1.45rem, 2.4vw, 2.05rem);
    line-height: 1.25;
    margin: 1.5rem 0 .75rem;
    color: #221c5d;
  }
  .login-brand p.lead { color: #64748b; font-size: .95rem; margin-bottom: 0; }
  .brand-feature { display: flex; align-items: flex-start; gap: .8rem; margin-bottom: .95rem; }
  .brand-feature .bf-icon {
    flex-shrink: 0;
    width: 40px; height: 40px;
    border-radius: 12px;
    display: flex; align-items: center; justify-content: center;
    background: rgba(229,106,34,0.12);
    color: #e56a22;
    font-size: 1.2rem;
    border: 1px solid rgba(229,106,34,0.25);
  }
  .brand-feature .bf-title { font-weight: 600; font-size: .92rem; color: #1f2a44; }
  .brand-feature .bf-sub { color: #64748b; font-size: .8rem; }
  .brand-payments img {
    height: 18px;
    object-fit: contain;
    background: #fff;
    border: 1px solid #e9edf5;
    border-radius: 5px;
    padding: 2px 5px;
  }

  /* Form side */
  .login-form-side { padding: 2.5rem 2.5rem; background: #fff; }
  .login-modern .login-logo { height: clamp(60px, 9vw, 92px); width: auto; max-width: 100%; object-fit: contain; }
  .login-modern h5.welcome { font-weight: 700; color: #221c5d; }
  .login-modern .welcome-sub { color: #64748b; font-size: .9rem; }

  /* Segmented tabs */
  .seg-tabs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: .35rem;
    background: #f1f3f9;
    border-radius: 14px;
    padding: .35rem;
    border: 1px solid #e6e9f2;
  }
  .seg-tabs .seg-tab {
    border: none;
    background: transparent;
    border-radius: 11px;
    padding: .62rem .5rem;
    font-weight: 600;
    font-size: .9rem;
    color: #64748b;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .4rem;
    transition: color .2s ease, background .2s ease, box-shadow .2s ease;
  }
  .seg-tabs .seg-tab:hover { color: #334155; }
  .seg-tabs .seg-tab.account.active { background: #e56a22; color: #fff; box-shadow: 0 6px 16px rgba(229,106,34,0.35); }
  .seg-tabs .seg-tab.company.active { background: #221c5d; color: #fff; box-shadow: 0 6px 16px rgba(34,28,93,0.35); }

  /* Inputs */
  .login-modern .form-label { font-weight: 600; font-size: .82rem; color: #334155; margin-bottom: .3rem; }
  .login-modern .login-ig { position: relative; }
  .login-modern .login-ig .ig-icon {
    position: absolute;
    left: 14px;
    top: 24px;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 1.15rem;
    pointer-events: none;
    z-index: 3;
  }
  .login-modern .login-ig .form-control {
    height: 48px;
    border-radius: 12px;
    border: 1.5px solid #e2e8f0;
    background: #f8fafc;
    padding-left: 42px;
    padding-right: 44px;
    font-size: .95rem;
    transition: border-color .2s, box-shadow .2s, background .2s;
  }
  .login-modern .login-ig .form-control:focus {
    border-color: #221c5d;
    background: #fff;
    box-shadow: 0 0 0 4px rgba(34,28,93,0.12);
  }
  .login-modern.tab-account .login-ig .form-control:focus {
    border-color: #e56a22;
    box-shadow: 0 0 0 4px rgba(229,106,34,0.15);
  }
  .login-modern .login-ig .form-control.is-invalid {
    border-color: #dc3545;
    background: #fff;
    background-image: none;
  }
  .login-modern .login-ig .pass-toggle {
    position: absolute;
    right: 8px;
    top: 24px;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    color: #94a3b8;
    padding: .35rem .5rem;
    z-index: 3;
    cursor: pointer;
    line-height: 1;
  }
  .login-modern .login-ig .pass-toggle:hover { color: #334155; }
  .login-modern .invalid-feedback { display: block; font-size: .78rem; margin-top: .3rem; }

  /* Button */
  .login-modern .btn-login {
    width: 100%;
    height: 50px;
    border: none;
    border-radius: 12px;
    font-weight: 600;
    font-size: 1rem;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    transition: transform .15s ease, box-shadow .2s ease, filter .2s ease;
  }
  .login-modern .btn-login.account { background: linear-gradient(135deg, #e56a22 0%, #f0823a 100%); box-shadow: 0 10px 24px rgba(229,106,34,0.35); }
  .login-modern .btn-login.company { background: linear-gradient(135deg, #221c5d 0%, #322a86 100%); box-shadow: 0 10px 24px rgba(34,28,93,0.35); }
  .login-modern .btn-login:hover { transform: translateY(-2px); filter: brightness(1.05); }
  .login-modern .btn-login:active { transform: translateY(0); }

  .login-modern .forgot-link { font-size: .82rem; color: #64748b; text-decoration: none; }
  .login-modern .forgot-link:hover { color: #221c5d; text-decoration: underline; }
  .login-modern .register-cta { color: #221c5d; font-weight: 600; text-decoration: none; }
  .login-modern .register-cta:hover { text-decoration: underline; }

  .login-modern .tab-content { animation: lgFade .35s ease-out; }
  @keyframes lgFade { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }

  /* Footer (beyaz) */
  .auth-footer-modern {
    position: relative;
    z-index: 1;
    background: #ffffff;
    border-top: 1px solid #e9edf5;
  }
  .auth-footer-modern .footer-links { gap: clamp(.3rem, 1vw, .75rem); font-size: clamp(.68rem, .9vw, .82rem); }
  .auth-footer-modern .footer-links span { cursor: pointer; color: #64748b; transition: color .2s; }
  .auth-footer-modern .footer-links span:hover { color: #221c5d; }
  .auth-footer-modern .copyright, .auth-footer-modern .copyright a { color: #94a3b8; }

  /* Responsive */
  @media (max-width: 991.98px) {
    .login-brand { display: none; }
    .login-card { grid-template-columns: 1fr; max-width: 460px; }
    .login-form-side { padding: 2rem 1.5rem; }
  }
  @media (max-width: 575.98px) {
    .login-card { margin: 1rem auto; border-radius: 18px; }
    .login-form-side { padding: 1.5rem 1.15rem; }
    .auth-footer-modern .footer-links { font-size: .7rem; }
  }
  @media (prefers-reduced-motion: reduce) {
    .login-modern *, .login-modern *::before, .login-modern *::after { animation: none !important; transition: none !important; }
    .login-modern .btn-login:hover { transform: none; }
  }
  `;




  // Fetch company logo when company code changes
  useEffect(() => {
    const fetchCompanyLogo = async () => {
      setLogoLoading(true); // Yükleme başladı
      try {
        const logoResponse = await axios.get(API.get_company_logo, {
          responseType: 'blob'
        });

        if (logoResponse.data && logoResponse.data.size > 0) {
          const logoUrl = URL.createObjectURL(logoResponse.data);
          setCompanyLogo(logoUrl);
        } else {
          setCompanyLogo(defaultLogo);
        }
      } catch (err) {
        console.error("Logo fetch error:", err);
        setCompanyLogo(defaultLogo);
      } finally {
        setLogoLoading(false); // Yükleme tamamlandı
      }
    };


    fetchCompanyLogo();
  }, []);


  // Tab toggle function
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setTwoFaRequired(false);
      setFrontCode(null);
      setVerifyCode("");
      setErrorMessage("");
      setCompanyCode("");
      validation.resetForm();
    }
  };

  // Formik configuration handles login and 2FA
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      companyCode: "",
      accountCode: "",
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      companyCode: activeTab === "company"
          ? Yup.string()
              .matches(/^\d+$/, "Sadece rakam giriniz")
              .required("Lütfen şirket kodunu giriniz")
          : Yup.string(),
      accountCode: activeTab === "account"
          ? Yup.string()
              .matches(/^\d+$/, "Sadece rakam giriniz")
              .required("Lütfen cari kodunu giriniz")
          : Yup.string(),

      email: Yup.string()
          .email("Geçerli bir e-posta adresi giriniz")   // <-- yeni kural
          .required("Lütfen e-posta adresinizi giriniz"),
      password: Yup.string().required("Lütfen şifrenizi giriniz"),
    }),
    onSubmit: async values => {
      setErrorMessage("");

      // Prepare payload based on active tab
      const payload = {
        email: values.email,
        password: sanitizePassword(values.password),

      };

      if (activeTab === "company") {
        payload.companyCode = values.companyCode;
      } else {
        payload.accountCode = values.accountCode;
      }

      if (!twoFaRequired) {
        // Initial login step
        try {
          const res = await axios.post(API.login, payload);
          const responseData = res.data;

          if (responseData.data.twoFaRequired) {
            // Trigger 2FA flow
            setTwoFaRequired(true);
            setFrontCode(responseData.data.frontCode);
          } else {
            // No 2FA, proceed
            // Token artık backend tarafından HttpOnly cookie olarak set edildi.
            // Body'deki token yalnızca exp okumak için decode edilir, localStorage'a yazılmaz.
            const rawToken = responseData.data.token;
            if (rawToken) {
              try {
                const decoded = jwtDecode(rawToken);
                if (decoded.exp) localStorage.setItem("tokenExp", decoded.exp);
              } catch {}
            }

            if (rawToken) {
              const authUser = {
                ...(activeTab === "company" ? { companyCode: values.companyCode } : { accountCode: values.accountCode }),
                email: values.email,
                user: responseData.data,
                loginTime: new Date().toISOString(),
                loginType: activeTab
              };
              localStorage.setItem("authUser", JSON.stringify(authUser));

              setTimeout(() => {
                props.router.navigate("/dashboard");
              }, 100);
            }
          }
        } catch (err) {
          const msg = err.response?.data?.message
              || (err.code === "ERR_NETWORK" || !err.response
                  ? "Sunucuya ulaşılamıyor. Lütfen internet bağlantınızı kontrol edin."
                  : "Giriş başarısız. Lütfen tekrar deneyin.");
          setErrorMessage(msg);
          console.error("Login error:", err);
        }
      } else {
        // 2FA verification step
        try {
          const verifyBody = {
            email: values.email,
            frontCode: frontCode,
            verifyCode: verifyCode
          };

          // Add appropriate code based on login type
          if (activeTab === "company") {
            verifyBody.companyCode = values.companyCode;
          } else {
            verifyBody.accountCode = values.accountCode;
          }

          const verifyRes = await axios.post(API.verify2fa, verifyBody);
          // Token artık backend tarafından HttpOnly cookie olarak set edildi.
          const rawToken = verifyRes.data.data.token;
          if (rawToken) {
            try {
              const decoded = jwtDecode(rawToken);
              if (decoded.exp) localStorage.setItem("tokenExp", decoded.exp);
            } catch {}

            const authUser = {
              ...(activeTab === "company" ? { companyCode: values.companyCode } : { accountCode: values.accountCode }),
              email: values.email,
              user: verifyRes.data.data,
              loginTime: new Date().toISOString(),
              loginType: activeTab
            };
            localStorage.setItem("authUser", JSON.stringify(authUser));

            setTimeout(() => {
              props.router.navigate("/dashboard");
            }, 100);
          }
        } catch (err) {
          setErrorMessage(err.response?.data?.message || "İki adımlı doğrulama başarısız. Lütfen tekrar deneyin.");
          console.error("2FA verification error:", err);
        }
      }
    }
  });



  // Social login handlers remain unchanged
  const signIn = type => {
    dispatch(socialLogin(type, props.router.navigate));
  };
  const socialResponse = type => {
    signIn(type);
  };

  document.title = "Giriş Yap | Tahsilat360";

  const isAccount = activeTab === "account";

  return (
      <React.Fragment>
        <style>{customStyles}</style>
        <div className={`login-modern tab-${activeTab}`}>
          <div className="login-scroll px-3 px-sm-4">
            <div className="login-card">

              {/* Sol marka paneli (lg ve üzeri) */}
              <div className="login-brand">
                <div>
                  <span className="brand-badge">
                    <i className="mdi mdi-shield-check-outline"></i> Güvenli Online Tahsilat
                  </span>
                  <h2>Tahsilatınızı dijitalleştirin, ödeme sürecinizi hızlandırın.</h2>
                  <p className="lead">
                    Tahsilat360 ile kredi kartı, link ile ödeme ve cari takibini tek panelden yönetin.
                  </p>
                </div>

                <div className="mt-4">
                  <div className="brand-feature">
                    <div className="bf-icon"><i className="mdi mdi-credit-card-fast-outline"></i></div>
                    <div>
                      <div className="bf-title">Hızlı &amp; Güvenli Ödeme</div>
                      <div className="bf-sub">3D Secure korumalı sanal POS altyapısı</div>
                    </div>
                  </div>
                  <div className="brand-feature">
                    <div className="bf-icon"><i className="mdi mdi-link-variant"></i></div>
                    <div>
                      <div className="bf-title">Link ile Tahsilat</div>
                      <div className="bf-sub">Tek tıkla ödeme linki oluşturup paylaşın</div>
                    </div>
                  </div>
                  <div className="brand-feature">
                    <div className="bf-icon"><i className="mdi mdi-chart-box-outline"></i></div>
                    <div>
                      <div className="bf-title">Cari Takip &amp; Raporlama</div>
                      <div className="bf-sub">Bakiye, vade takibi ve anlık raporlar</div>
                    </div>
                  </div>
                </div>

                <div className="brand-payments d-flex flex-wrap align-items-center gap-1 mt-3">
                  <img src="/images/secure-payment/footer-logo-visa.png" alt="Visa" />
                  <img src="/images/secure-payment/footer-logo-mastercard.png" alt="Mastercard" />
                  <img src="/images/secure-payment/footer-logo-troy.png" alt="Troy" />
                  <img src="/images/secure-payment/footer-logo-amex.png" alt="American Express" />
                </div>
              </div>

              {/* Sağ form paneli */}
              <div className="login-form-side">
                <div className="text-center mb-3">
                  <Link to="/dashboard" className="d-inline-block auth-logo">
                    <img
                        src={companyLogo || defaultLogo}
                        alt="Logo"
                        className="login-logo img-fluid"
                        onError={() => companyLogo !== defaultLogo && setCompanyLogo(defaultLogo)}
                    />
                  </Link>
                </div>

                <div className="text-center mb-4">
                  <h5 className="welcome mb-1">Tekrar Hoş Geldiniz!</h5>
                  <p className="welcome-sub mb-0">Tahsilat360'a giriş yapmak için oturum açın.</p>
                </div>

                {/* Segmented tab kontrolü */}
                <div className="seg-tabs mb-4" role="tablist">
                  <button
                      type="button"
                      role="tab"
                      aria-selected={isAccount}
                      className={classnames("seg-tab account", { active: isAccount })}
                      onClick={() => toggleTab("account")}
                  >
                    <i className="mdi mdi-account-outline"></i>
                    Cari/Bayi Giriş
                  </button>
                  <button
                      type="button"
                      role="tab"
                      aria-selected={!isAccount}
                      className={classnames("seg-tab company", { active: !isAccount })}
                      onClick={() => toggleTab("company")}
                  >
                    <i className="mdi mdi-office-building-outline"></i>
                    Firma Giriş
                  </button>
                </div>

                <TabContent activeTab={activeTab} key={activeTab}>
                  <TabPane tabId="company">
                    <Form
                        className="custom-form"
                        onSubmit={e => { e.preventDefault(); validation.handleSubmit(); return false; }}
                    >
                      <div className="mb-3">
                        <Label className="form-label" for="c_companyCode">Firma Kodu</Label>
                        <div className="login-ig">
                          <i className="mdi mdi-office-building-outline ig-icon"></i>
                          <Input
                              id="c_companyCode"
                              name="companyCode"
                              placeholder="Firma Kodunu Girin"
                              inputMode="numeric"          // mobil klavye
                              pattern="[0-9]*"
                              type="text"
                              onChange={e => {
                                const digits = onlyDigits(e.target.value);
                                validation.setFieldValue("companyCode", digits);
                                setCompanyCode(digits);
                              }}
                              onBlur={validation.handleBlur}
                              value={validation.values.companyCode}
                              invalid={validation.touched.companyCode && validation.errors.companyCode}
                          />
                          {validation.touched.companyCode && validation.errors.companyCode && (
                              <FormFeedback>{validation.errors.companyCode}</FormFeedback>
                          )}
                        </div>
                      </div>

                      <div className="mb-3">
                        <Label className="form-label" for="c_email">E-posta</Label>
                        <div className="login-ig">
                          <i className="mdi mdi-email-outline ig-icon"></i>
                          <Input
                              id="c_email"
                              name="email"
                              placeholder="E-posta Adresinizi Girin"
                              type="email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email}
                              invalid={validation.touched.email && validation.errors.email}
                          />
                          {validation.touched.email && validation.errors.email && (
                              <FormFeedback>{validation.errors.email}</FormFeedback>
                          )}
                        </div>
                      </div>

                      <div className="mb-3">
                        <div className="d-flex align-items-center justify-content-between">
                          <Label className="form-label mb-0" for="c_password">Şifre</Label>
                          <Link to={`/forgot-password?type=${activeTab}`} className="forgot-link">Şifremi Unuttum?</Link>
                        </div>
                        <div className="login-ig mt-1">
                          <i className="mdi mdi-lock-outline ig-icon"></i>
                          <Input
                              id="c_password"
                              name="password"
                              type={passwordShow ? "text" : "password"}
                              placeholder="Şifrenizi Girin"
                              autoComplete="new-password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.password}
                              invalid={validation.touched.password && validation.errors.password}
                          />
                          <button
                              type="button"
                              className="pass-toggle"
                              aria-label={passwordShow ? "Şifreyi gizle" : "Şifreyi göster"}
                              onClick={() => setPasswordShow(prev => !prev)}
                          >
                            <i className={passwordShow ? "mdi mdi-eye-outline" : "mdi mdi-eye-off-outline"}></i>
                          </button>
                          {validation.touched.password && validation.errors.password && (
                              <FormFeedback>{validation.errors.password}</FormFeedback>
                          )}
                        </div>
                      </div>

                      {/* 2FA input field */}
                      {twoFaRequired && (
                          <div className="mb-3">
                            <Label className="form-label" for="c_verifyCode">2FA Kodu</Label>
                            <div className="login-ig">
                              <i className="mdi mdi-shield-key-outline ig-icon"></i>
                              <Input
                                  id="c_verifyCode"
                                  name="verifyCode"
                                  placeholder="2FA Kodunuzu Girin"
                                  type="text"
                                  value={verifyCode}
                                  onChange={e => setVerifyCode(e.target.value)}
                              />
                            </div>
                          </div>
                      )}

                      <div className="mt-4">
                        <button className="btn-login company" type="submit">
                          {twoFaRequired ? "2FA Doğrula" : "Firma Girişi"}
                          <i className="mdi mdi-arrow-right"></i>
                        </button>
                      </div>
                    </Form>
                  </TabPane>

                  <TabPane tabId="account">
                    <Form
                        className="custom-form"
                        onSubmit={e => { e.preventDefault(); validation.handleSubmit(); return false; }}
                    >
                      <div className="mb-3">
                        <Label className="form-label" for="a_accountCode">Cari/Bayi Kodu</Label>
                        <div className="login-ig">
                          <i className="mdi mdi-account-outline ig-icon"></i>
                          <Input
                              id="a_accountCode"
                              name="accountCode"
                              placeholder="Cari Kodunu Girin"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              type="text"
                              onChange={e => {
                                const digits = onlyDigits(e.target.value);
                                validation.setFieldValue("accountCode", digits);
                              }}
                              onBlur={validation.handleBlur}
                              value={validation.values.accountCode}
                              invalid={validation.touched.accountCode && validation.errors.accountCode}
                          />
                          {validation.touched.accountCode && validation.errors.accountCode && (
                              <FormFeedback>{validation.errors.accountCode}</FormFeedback>
                          )}
                        </div>
                      </div>

                      <div className="mb-3">
                        <Label className="form-label" for="a_email">E-posta</Label>
                        <div className="login-ig">
                          <i className="mdi mdi-email-outline ig-icon"></i>
                          <Input
                              id="a_email"
                              name="email"
                              placeholder="E-posta Adresinizi Girin"
                              type="email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email}
                              invalid={validation.touched.email && validation.errors.email}
                          />
                          {validation.touched.email && validation.errors.email && (
                              <FormFeedback>{validation.errors.email}</FormFeedback>
                          )}
                        </div>
                      </div>

                      <div className="mb-3">
                        <div className="d-flex align-items-center justify-content-between">
                          <Label className="form-label mb-0" for="a_password">Şifre</Label>
                          <Link to={`/forgot-password?type=${activeTab}`} className="forgot-link">Şifremi Unuttum?</Link>
                        </div>
                        <div className="login-ig mt-1">
                          <i className="mdi mdi-lock-outline ig-icon"></i>
                          <Input
                              id="a_password"
                              name="password"
                              type={passwordShow ? "text" : "password"}
                              placeholder="Şifrenizi Girin"
                              onChange={validation.handleChange}
                              autoComplete="new-password"
                              onBlur={validation.handleBlur}
                              value={validation.values.password}
                              invalid={validation.touched.password && validation.errors.password}
                          />
                          <button
                              type="button"
                              className="pass-toggle"
                              aria-label={passwordShow ? "Şifreyi gizle" : "Şifreyi göster"}
                              onClick={() => setPasswordShow(prev => !prev)}
                          >
                            <i className={passwordShow ? "mdi mdi-eye-outline" : "mdi mdi-eye-off-outline"}></i>
                          </button>
                          {validation.touched.password && validation.errors.password && (
                              <FormFeedback>{validation.errors.password}</FormFeedback>
                          )}
                        </div>
                      </div>

                      {/* 2FA input field */}
                      {twoFaRequired && (
                          <div className="mb-3">
                            <Label className="form-label" for="a_verifyCode">2FA Kodu</Label>
                            <div className="login-ig">
                              <i className="mdi mdi-shield-key-outline ig-icon"></i>
                              <Input
                                  id="a_verifyCode"
                                  name="verifyCode"
                                  placeholder="2FA Kodunuzu Girin"
                                  type="text"
                                  value={verifyCode}
                                  onChange={e => setVerifyCode(e.target.value)}
                              />
                            </div>
                          </div>
                      )}

                      <div className="mt-4">
                        <button className="btn-login account" type="submit">
                          {twoFaRequired ? "2FA Doğrula" : "Cari Giriş"}
                          <i className="mdi mdi-arrow-right"></i>
                        </button>
                      </div>
                    </Form>
                  </TabPane>
                </TabContent>

                {errorMessage && (
                    <div className="alert alert-danger mt-3 mb-0 d-flex align-items-center gap-2" role="alert">
                      <i className="mdi mdi-alert-circle-outline"></i>
                      <span>{errorMessage}</span>
                    </div>
                )}

                <div className="mt-4 text-center">
                  <p className="text-muted mb-0" style={{ fontSize: ".9rem" }}>
                    Hesabınız yok mu?{" "}
                    <Link to="/register" className="register-cta">Hesap Oluştur</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <footer className="auth-footer-modern">
            <Container fluid className="px-3 px-sm-4">
              <Row className="align-items-center pt-2">
                <Col lg={12} className="text-center mb-2">
                  <div className="footer-links d-flex justify-content-center flex-wrap mb-2">
                    <span role="button" onClick={openContactModal}>İletişim</span>
                    <span role="button" onClick={() => openContractModal("CANCELLATION")}>İptal, İade Koşulları ve Gizlilik</span>
                    <span role="button" onClick={() => openContractModal("KVKK")}>Kişisel Veriler Politikası</span>
                    <span role="button" onClick={() => openContractModal("SERVICE")}>Hizmet Sözleşmesi</span>
                  </div>
                </Col>
              </Row>
              <Row className="border-top border-light border-opacity-25 pt-2 pb-2">
                <Col className="text-center copyright">
                  <a href="https://tahsilat360.com/" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block" }}>
                    <img src={tahsilat360Logo} alt="Tahsilat360" style={{ maxHeight: "30px" }} />
                  </a>
                  <p className="small mb-0 mt-1">
                    <a href="https://tahsilat360.com/" target="_blank" rel="noopener noreferrer" className="text-decoration-none copyright">
                      © {new Date().getFullYear()} Tahsilat360 | Online Tahsilat Sistemi. Tüm hakları saklıdır.
                    </a>
                  </p>
                </Col>
              </Row>
            </Container>
          </footer>
        </div>

        <Modal isOpen={contractModal.open} toggle={() => setContractModal(p => ({ ...p, open:false }))} size="lg">
          <ModalHeader toggle={() => setContractModal(p => ({ ...p, open:false }))}>
            {contractModal.title}
          </ModalHeader>
          <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
            {contractModal.busy ? (
                <div className="text-center py-4">
                  <span className="spinner-border" />
                </div>
            ) : (
                <div
                    style={{ whiteSpace: "pre-wrap" }}
                    dangerouslySetInnerHTML={{ __html: contractModal.html }}
                />
            )}
          </ModalBody>
        </Modal>

        <Modal
            isOpen={contactModal.open}
            toggle={() => setContactModal(p => ({ ...p, open:false }))}>
          <ModalHeader toggle={() => setContactModal(p => ({ ...p, open:false }))}>
            İletişim Bilgileri
          </ModalHeader>

          <ModalBody style={{ maxHeight:"70vh", overflowY:"auto" }}>
            {contactModal.busy && (
                <div className="text-center py-4">
                  <span className="spinner-border" />
                </div>
            )}

            {!contactModal.busy && contactModal.error && (
                <p className="text-danger">{contactModal.error}</p>
            )}

            {!contactModal.busy && contactModal.data && (
                <div style={{ whiteSpace:"pre-wrap" }}>
                  <strong>{contactModal.data.companyName}</strong>{"\n\n"}

                  {contactModal.data.phoneNumber && (
                      <>
                        <strong>Telefon:</strong> {contactModal.data.phoneNumber}{"\n"}
                      </>
                  )}

                  {contactModal.data.contactEmail && (
                      <>
                        <strong>E-posta:</strong> {contactModal.data.contactEmail}{"\n"}
                      </>
                  )}

                  {contactModal.data.address && (
                      <>
                        <strong>Adres:</strong>{"\n"}{contactModal.data.address}
                      </>
                  )}
                </div>
            )}
          </ModalBody>
        </Modal>
      </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
